import { render, staticRenderFns } from "./ImportExpedientsLoadingComponent.vue?vue&type=template&id=e060f300&scoped=true"
import script from "./ImportExpedientsLoadingComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportExpedientsLoadingComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ImportExpedientsLoadingComponent.vue?vue&type=style&index=0&id=e060f300&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e060f300",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e060f300')) {
      api.createRecord('e060f300', component.options)
    } else {
      api.reload('e060f300', component.options)
    }
    module.hot.accept("./ImportExpedientsLoadingComponent.vue?vue&type=template&id=e060f300&scoped=true", function () {
      api.rerender('e060f300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Expedients/components/ImportExpedientsDialog/components/ImportExpedientsLoadingComponent.vue"
export default component.exports